import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appGetAllProject } from '../../store/socialproject'
import { socialProjectExportColumns } from '../../config/exportColumns/socialProjectExportColumns'
import { useDispatch } from 'react-redux'

function SocialProject() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Social Project</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllProject({ ...params, loading: false }))}
							filters={{}}
							columns={socialProjectExportColumns}
							fileName="Social Projects"
							sheetName="Social Project List"
							buttonText="Export Social Projects"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/social-project/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Social Project
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default SocialProject
